export const dateFormatedString = (date: Date) => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
};

export const fromStringToDate = (dateString: String) => {
  const [dayStr, monthStr, yearStr] = (dateString as string).split('/');
  const day = parseInt(dayStr, 10);
  const month = parseInt(monthStr, 10) - 1; // JS months are 0-based
  const year = parseInt(yearStr, 10);
  // Construir fecha en hora local para evitar interpretación UTC y cambios de día
  return new Date(year, month, day);
};

export const nextDayOfDate = (date: string | number | Date) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 1);
  return newDate;
};

export const next3DaysOfDate = (date: string | number | Date) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + 3);
  return newDate;
};

export const next3BusinessDays = (
  date: string | number | Date,
  businessDays?: number
) => {
  // Si se proporciona businessDays, usar ese valor; por defecto 3
  const daysToAdd = typeof businessDays === 'number' ? businessDays : 3;

  // Avanza exactamente "daysToAdd" días laborables (L-V), excluyendo Sáb/Dom
  const result = new Date(date);
  if (daysToAdd <= 0) return result;

  let remaining = daysToAdd;
  while (remaining > 0) {
    result.setDate(result.getDate() + 1);
    const d = result.getDay();
    // 0 = Domingo, 6 = Sábado
    if (d !== 0 && d !== 6) {
      remaining -= 1;
    }
  }

  return result;
};
